module.exports = __webpack_public_path__ + "static/media/CircleMenuItem.b791272f.less";